import { AddressInputUniDriver } from '../AddressInput/AddressInput.uni.driver';

export type AtlasAddressInputUniDriver = AddressInputUniDriver;
